
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.314 14.886l-.006-.002L9.181 8.07a.775.775 0 00-.786.083.924.924 0 00-.29.342 1.013 1.013 0 00-.105.45v4.358c0 .215.07.423.195.588a.84.84 0 00.496.318l8.25 1.657a.14.14 0 01.084.053.163.163 0 010 .196.14.14 0 01-.083.053l-8.25 1.657a.84.84 0 00-.496.317.972.972 0 00-.196.589v4.358c0 .15.034.298.1.43.065.132.16.245.275.327a.8.8 0 00.806.08l15.126-6.775.007-.003c.204-.095.377-.253.5-.454.121-.2.186-.436.186-.677 0-.24-.065-.476-.187-.677a1.161 1.161 0 00-.499-.454z","fill":"#282E3E"}})])
          )
        }
      }
    